import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FieldsetModule } from 'primeng/fieldset';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { MenubarModule } from 'primeng/menubar';
import { PanelModule } from 'primeng/panel';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AccordionModule } from 'primeng/accordion';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { SliderModule } from 'primeng/slider';
import { CarouselModule } from 'primeng/carousel';
@NgModule({
  declarations: [],
  imports: [
    ButtonModule,
    CardModule,
    FieldsetModule,
    TableModule,
    CalendarModule,
    MenubarModule,
    PanelModule,
    OverlayPanelModule,
    MenuModule,
    InputTextareaModule,
    InputSwitchModule,
    AccordionModule,
    DropdownModule,
    DialogModule,
    ToastModule,
    CheckboxModule,
    RadioButtonModule,
    FileUploadModule,
    TooltipModule,
    SliderModule,
    CarouselModule
  ],
  exports: [
    ButtonModule,
    CardModule,
    FieldsetModule,
    TableModule,
    CalendarModule,
    MenubarModule,
    PanelModule,
    OverlayPanelModule,
    MenuModule,
    InputTextareaModule,
    InputSwitchModule,
    AccordionModule,
    DropdownModule,
    DialogModule,
    ToastModule,
    CheckboxModule,
    RadioButtonModule,
    FileUploadModule,
    SliderModule,
    CarouselModule
  ]
})
export class PrimengModule { }
